import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../PageLayout/LoginLayout";
import { requestPasswordReset } from "../services/auth.service";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleContinue = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    if (!email) {
      setError("Please enter your email.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await requestPasswordReset(email);
      // success → go to verify code page
      try { localStorage.setItem("pendingPasswordResetEmail", email); } catch (_) {}
      navigate("/reset-verify", { state: { email } });
    } catch (err) {
      console.error("❌ Error sending reset code:", err);
      const msg = err?.response?.data?.message || err.message || "Failed to send reset code.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      {/* Back link */}
      <Link
        to="/login"
        className="text-sm text-gray-500 hover:underline flex items-center mb-6"
      >
      {/* Back button */}
      <button
            type="button"
            onClick={() => navigate(-1)}
            className="mb-4 inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" transform="scale(-1,1) translate(-20,0)" />
            </svg>
            Back
          </button>
      </Link>

      {/* Title */}
      <h2 className="text-2xl font-semibold mb-1">Reset your password</h2>

      {/* Description */}
      <p className="text-sm text-gray-500 mb-6">
        We need your email address so we can send you the password reset link.
      </p>

      <form onSubmit={handleContinue}>
        {/* Email Input */}
        <div className="mb-4">
          <input
            type="email"
            placeholder="name.surname@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-gray-300 rounded-md py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Error Message */}
        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

        {/* Continue Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#1E1E2F] text-white rounded-md py-2 text-sm font-medium hover:bg-gray-800 disabled:opacity-50"
        >
          {loading ? "Sending..." : "Continue"}
        </button>
      </form>
    </Layout>
  );
}
